export default class DtoApplicationHabilitation {
    constructor(obj) {
        this.habilitationType = obj.habilitationType
        this.parameter = obj.parameter
        this.title = obj.title
    }
}